// main.js

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";

import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";

// PrimeVue Components
import Editor from "primevue/editor";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import axios from "./utils/axios";
import Moment from "moment";
import Swal from "sweetalert2";
import OrganizationChart from "primevue/organizationchart";

import VueGoogleMaps from "@fawmi/vue-google-maps";

// --------------------
// Define Gazette Roles
// --------------------
export const GAZETTE_ROLES = ["admin", "super", "moderator", "creator", "coordinator"]; // Centralized Role list, add here

// Create the app instance
const app = createApp(App);

// Provide roles globally
app.provide("GAZETTE_ROLES", GAZETTE_ROLES);

// --------------------
// PrimeVue Setup
// --------------------
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: { darkModeSelector: false },
  },
});

// Vuex & Router
app.use(store);
app.use(router);

// PrimeVue Plugins
app.use(ToastService);
app.provide("$axios", axios);
app.provide("$moment", Moment);
app.provide("$swal", Swal);

// Register Components
app.component("PrimeEditor", Editor);
app.component("VueToast", Toast);
app.component("OrganizationChart", OrganizationChart);

// Google Maps
app.use(VueGoogleMaps, {
  load: { key: "AIzaSyDwYYhQEcBZw0qLW3GlJ6VHAeNGsXhq_O0", libraries: "places", async: true },
});

// --------------------
// Mount
// --------------------
app.mount("#app");